
// What a client sees at /summary/{id} (Aziz 2026-10-03): the PDF frozen when
// the summary was sent, not the live page, which recomputes from today's data
// (flow/consults/summary_copies.py). Each load is recorded server-side with
// the copy it served.
import { summaryCopyCaption } from '~/util/summary-copy'

export default {
    props: {
        copy: { type: Object, required: true },
    },
    computed: {
        caption () {
            return summaryCopyCaption(this.copy, this.$moment)
        },
        // The browser's PDF viewer otherwise fits the page to the frame and
        // opens it shrunk (Aziz 2026-10-03); Chrome and Firefox read the
        // PDF open parameter.
        frameUrl () {
            return `${this.copy.url}#zoom=100`
        },
    },
}
